<script setup lang="ts">
import ArrowRightIcon from '@/assets/icons/ArrowRightIcon.vue';
import BillingProBadge from './BillingProBadge.vue';

// `aria-label` is passed by consumers and falls through to the root button.
defineProps<{
  description: string;
  title: string;
}>();

const emit = defineEmits<{ action: [] }>();
</script>

<template>
  <button
    type="button"
    class="group flex w-full items-center gap-md rounded-group bg-surface-secondary p-md text-left transition duration-300 [container-type:inline-size] hover:bg-tertiary focus-visible:outline-focus focus-visible:outline-offset-2 active:bg-surface-tertiary md:p-lg"
    @click="emit('action')"
  >
    <span class="flex size-cell shrink-0 items-center justify-center rounded-full bg-white">
      <slot name="icon" />
    </span>
    <span class="flex min-w-0 flex-1 flex-col gap-xs">
      <span class="flex flex-wrap items-center gap-sm">
        <BillingProBadge theme="gray" class="order-1 [@container(min-width:520px)]:order-3" />
        <span class="order-2 text-body font-semibold text-primary">{{ title }}</span>
      </span>
      <span class="text-body text-secondary">{{ description }}</span>
    </span>
    <span
      class="hidden shrink-0 items-center gap-xs text-body font-semibold text-tint [@container(min-width:520px)]:flex"
    >
      {{ $t('billing.buttons.chooseSubscription') }}
      <ArrowRightIcon class="size-icon-sm transition-transform group-hover:translate-x-1" />
    </span>
    <ArrowRightIcon class="size-icon shrink-0 text-tint [@container(min-width:520px)]:hidden" />
  </button>
</template>
